module.exports = __webpack_public_path__ + "img/Feedback@3x.8b5eb2f8.png";